import { render, staticRenderFns } from "./FacebookPost.vue?vue&type=template&id=1620b59a&"
import script from "./FacebookPost.vue?vue&type=script&lang=js&"
export * from "./FacebookPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports